import { render, staticRenderFns } from "./DialogUpdateSort.vue?vue&type=template&id=4d13a3c9&"
import script from "./DialogUpdateSort.vue?vue&type=script&lang=js&"
export * from "./DialogUpdateSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports